module.exports = __webpack_public_path__ + "img/8140334.svg";